import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export default {
  state: {
    analyticsList: [],
    analyticsFilters: [],
    analyticsReport: {},
    analyticsData: [],
    analyticsDataGraph: [],
    analyticsDataView: [],
    analyticsDataSum: null,
    reportInfo: null,
    tableHeaders: [],
    analyticsFormatName: '',
    dataList: [],
    detailsList: [],
    filtersList: [],
    dates: {
      start: null,
      end: null,
    },
    analyticsFillStudios: [],
  },
  getters: getters,
  mutations: mutations,
  actions: actions,
}
